import React, { PureComponent } from 'react';
import Carousel from 'nuka-carousel';

import {
  StyledWrapper,
  StyledHeader,
  StyledDescription,
  StyledSlide,
  StyledSliderDots,
  StyledSlideDot,
  StyledSlideTitle,
  StyledSlideLink,
} from "./slider.style";

import { StyledElementWrapperCenter } from 'styledElements';

// Images


// Texts
import text from 'i18l';


class Slider extends PureComponent {
  state = {
    sliderIndex: 0,
  };

  componentDidMount() {
    this.interval = setInterval(() => this.setAutoActiveSLide(), 5000);
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  };

  setAutoActiveSLide = () => {
    this.setState(prevState => ({
      sliderIndex: prevState.sliderIndex === (text.SLIDER.length - 1) ? 0 : prevState.sliderIndex + 1,
    }));
  };

  setActiveSlide = (activeSlide) => this.setState({sliderIndex: activeSlide});

  renderSliderContent = () => text.SLIDER.map((sliderItem) => (
    <StyledSlide key={sliderItem.key}>
      <StyledElementWrapperCenter>
        <StyledSlideTitle>
          <StyledHeader>{sliderItem.name}</StyledHeader>
          <StyledDescription>{sliderItem.description}</StyledDescription>
          <StyledSlideLink to={sliderItem.url}>
            DOWIEDZ SIĘ WIĘCEJ &raquo;
          </StyledSlideLink>
        </StyledSlideTitle>

      </StyledElementWrapperCenter>
    </StyledSlide>
  ));

  renderDots = () => text.SLIDER.map((sliderItem, index) => (
    <StyledSlideDot key={sliderItem.key} active={this.state.sliderIndex === index} onClick={() => this.setActiveSlide(index)} />
  ));

  render() {
    const { sliderIndex } = this.state;
    return (
      <StyledWrapper background={text.SLIDER[sliderIndex].image}>
          <Carousel
            withoutControls={true}
            slideIndex={this.state.sliderIndex}
            dragging={false}
            swiping={false}
          >
            {this.renderSliderContent()}
          </Carousel>
          <StyledSliderDots>
            <StyledElementWrapperCenter>
              {this.renderDots()}
            </StyledElementWrapperCenter>
          </StyledSliderDots>
      </StyledWrapper>
    );
  }
}

export default Slider;


// WEBPACK FOOTER //
// ./src/components/slider/slider.component.js